// Datos del comercio utilizados por el informe diario y el informe de frecuencia.
export const REPORT_COMPANY = {
  nombre: "PAGOS AUTOMATICOS DE COLOMBIA S.A.S",
  servicio: "CONTROLES ACCESO VEHICULAR",
  version: "LINCE V7.0.R3",
  razonSocial: "CENTRO COMERCIAL ISERRA 100 PH",
  nit: "830.019.348-2",
  idMaquina: "ISERRA 100",
};
